import * as React from "react";
import * as yup from "yup";
import { Form, Table, Modal, Segment, Message, ModalContent, ModalHeader, ModalActions, TableBody, TableRow, TableCell } from "@/components/bp/bp-ui";
import { LabClient, ReportTemplateResponse } from "@app/api2/api";
import { Formik } from "formik";
import SemanticField from "../../SemanticField";
import { FileUpload, IUploadedFile } from "../FileUpload";
import { areYouSure } from "../AreYouSure";
import { TranslationContext } from "../Contexts/TranslationContext";
import { BPButton } from "@/components/bp/bpbutton";

export interface LabReportingViewProps {
    readOnly: boolean;
    labId: number;
}

export class LabReportingView extends React.Component<LabReportingViewProps, { reportTemplate: ReportTemplateResponse; dialogOpen: boolean; }> {
    labClient = new LabClient();

    validationSchema: yup.AnyObjectSchema;

    constructor(props, context) {
        super(props, context);

        this.validationSchema = yup.object().shape({
            file: yup.object().shape({
                fileName: yup.string().required().nullable(false)
            }).required().nullable(false).typeError(window.translation.lab.pleaseSelectFile).label(window.translation.lab.dropInData),
        });

        this.state = {
            dialogOpen: false, reportTemplate: null, 
        };
    }

    async componentDidMount() {
        let result = await this.labClient.getReportTemplate(this.props.labId);

        this.setState({
            reportTemplate: result,
        });
    }

    async uploadDropInFile(file: IUploadedFile) {
        let res = await this.labClient.uploadReportTemplate(this.props.labId, file);
        this.componentDidMount();
    }

    @areYouSure(() => { return { message: window.translation.lab.deleteReportConfirm, title: window.translation.common.confirmDelete }; })
    async deleteReportTemplate() {
        let res = await this.labClient.deleteReportTemplate(this.props.labId);
        this.componentDidMount();
    }

    showUploadDialog() {
        this.setState({ dialogOpen: true });
    }

    setOpen(value: boolean) {
        this.setState({ dialogOpen: value });
    }

    render() {
        return (<TranslationContext.Consumer>{t => {
            return <>
                {this.state.reportTemplate == null &&
                    <BPButton onClick={() => this.showUploadDialog()}>{t.lab.uploadReportTemplateFile}</BPButton>}
                {this.state.reportTemplate != null &&
                    <>
                        <BPButton negative onClick={() => this.deleteReportTemplate()}>{t.common.delete}</BPButton>
                        <a className="ui button" href={this.state.reportTemplate != null ? this.state.reportTemplate.downloadUrl : ''}>{t.common.download}</a>
                    </>}
                <Modal open={this.state.dialogOpen} onClose={() => this.setOpen(false)} onOpen={() => this.setOpen(true)}>
                    <ModalHeader>{t.lab.uploadReportTemplateFile}</ModalHeader>
                    <ModalContent>
                        <Formik initialValues={{ file: null as IUploadedFile }}
                            validationSchema={this.validationSchema}
                            onSubmit={async (values, { setSubmitting }) => {

                                await this.uploadDropInFile(values.file);

                                setSubmitting(false);
                                this.setOpen(false);
                            } }>
                            {({ isSubmitting, handleSubmit, values, setFieldValue, setFieldTouched, errors, touched }) => {
                                var errorList = Object.getOwnPropertyNames(errors)
                                    .filter((k) => touched[k])
                                    .map((k) => errors[k]);

                                return (
                                    <Form id="form" onSubmit={handleSubmit}>
                                        <SemanticField component={FileUpload} name="file" label={t.lab.name} placeholderText={t.lab.reportTemplateFile} value={values.file} error={errors.file && touched.file} fileUploaded={async (e: string, v: IUploadedFile) => { await setFieldValue("file", v ? v : null); } } />
                                        <Message error header={t.common.errorsOnForm} list={errorList} visible={errorList.length > 0} />
                                    </Form>
                                );
                            } }
                        </Formik>
                    </ModalContent>
                    <ModalActions>
                        <BPButton form="form" type="submit">
                            {t.common.save}
                        </BPButton>
                        <BPButton onClick={() => this.setOpen(false)}>
                            {t.common.cancel}
                        </BPButton>
                    </ModalActions>
                </Modal>
                {this.state.reportTemplate != null &&
                    <Table definition>
                        <TableBody>
                            <TableRow>
                                <TableCell>{t.lab.reportTemplateFile}</TableCell>
                                <TableCell>{this.state.reportTemplate.filename}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>}
                {this.state.reportTemplate == null &&
                    <Segment>
                        {t.lab.noReportTemplates}
                    </Segment>}
            </>;
        }}</TranslationContext.Consumer>
        );
    }
}
